/* ===== Loading States Utility ===== */
import { $ } from './helpers.js?v=82.86';

// Show loading state on button
export function setButtonLoading(buttonId, isLoading, originalText = null, loadingText = null) {
  const btn = $(buttonId);
  if (!btn) return;
  
  if (isLoading) {
    btn.dataset.originalText = originalText || btn.textContent;
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.7';
    btn.textContent = loadingText || '⏳ Se încarcă...';
  } else {
    btn.disabled = false;
    btn.style.pointerEvents = '';
    btn.style.opacity = '1';
    btn.textContent = btn.dataset.originalText || originalText || 'Trimite';
  }
}

// Show loading overlay
export function showLoadingOverlay(message = 'Se încarcă...') {
  let overlay = $('loadingOverlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'loadingOverlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      color: white;
      font-size: 18px;
    `;
    document.body.appendChild(overlay);
  }
  overlay.innerHTML = '';
  const label = document.createElement('div');
  label.textContent = message;
  label.style.textAlign = 'center';
  label.style.padding = '0 24px';
  overlay.appendChild(label);
  overlay.style.display = 'flex';
  overlay.style.flexDirection = 'column';
  overlay.style.gap = '12px';
  overlay.setAttribute('aria-live', 'polite');
  overlay.setAttribute('role', 'status');
}

export function hideLoadingOverlay() {
  const overlay = $('loadingOverlay');
  if (overlay) {
    overlay.style.display = 'none';
  }
}

/* ===== Ecran de pornire (în loc de flash-ul cu „Intră în cont” când ești deja logat) ===== */
const SESSION_KEY = 'sj_session';

export function markSession(on) {
  try {
    if (on) localStorage.setItem(SESSION_KEY, '1');
    else localStorage.removeItem(SESSION_KEY);
  } catch (_) { /* ignore */ }
}

export function hadSession() {
  try { return localStorage.getItem(SESSION_KEY) === '1'; } catch (_) { return false; }
}

export function showBootSplash(message = 'Se încarcă…') {
  let n = document.getElementById('sjBootSplash');
  if (!n) {
    n = document.createElement('div');
    n.id = 'sjBootSplash';
    n.setAttribute('role', 'status');
    n.setAttribute('aria-live', 'polite');
    n.innerHTML = '<div class="sbs__brand"><i></i>SpressJoy</div><div class="sbs__spin" aria-hidden="true"></div><p class="sbs__msg"></p>';
    (document.body || document.documentElement).appendChild(n);
  }
  const msg = n.querySelector('.sbs__msg');
  if (msg) msg.textContent = message;
  return n;
}

export function hideBootSplash() {
  document.getElementById('sjBootSplash')?.remove();
}
